import React from 'react';
import classNameBind from 'classnames/bind';
import Text from '../../../Text';
import Label from '../../../Label';
import List from '../../../List';
import Tooltip from '../../../Tooltip';
import Icon from '../../../Icon';
import { getColumns } from '../InnerList/getColumns';
import styles from './InnerListItem.module.css';
import { DraggableWrapper } from '../DraggableWrapper';
import { NoopWrapper } from '../NoopWrapper';

const bindClasses = classNameBind.bind(styles);

const InnerListItem = ({
  name,
  handleChange,
  option,
  value,
  disabled,
  disabledTooltipText,
  draggable,
  index,
  customListColumns,
} = {}) => {
  const ListItemWrapper = draggable ? DraggableWrapper : NoopWrapper;

  return (
    <ListItemWrapper id={option.id} index={index}>
      {provided => (
        <List.Item
          columns={customListColumns ? customListColumns(option.side) : getColumns(!!option.rightLabel)}
          withSelect={{
            name,
            onChange: handleChange,
            value: option.id,
            checked: value.includes(option.id),
            disabled: disabled || option.disabled,
          }}
          id={option.side
            ? `${option.side}-${option.id}`
            : option.id
          }
          tabIndex={-1}
          className={bindClasses('ListItem')}
        >
          <div className={bindClasses('inner')}>
            {draggable && (
              <div
                {...provided.dragHandleProps}
                className={bindClasses('icon')}
                data-ppuc-id="SearchableMultiselectListbox.dragHandle"
              >
                <Icon name="draggable" />
              </div>
            )}
            {option.label || (
              <Label
                cutText
                data-ppuc-id="SearchableMultiselectListbox.optionName"
                disabled={option.disabled}
                title=""
              >
                {(option.disabled && disabledTooltipText)
                  ? <Tooltip title={disabledTooltipText}><div>{option.name}</div></Tooltip>
                  : option.name}
              </Label>
            )}
          </div>
          {customListColumns
            ? option.customColumnAttribute.name
            : option.rightLabel && (
              <Text type="subdued" dataId="SearchableMultiselectListbox.rightLabel">
                {option.rightLabel}
              </Text>
            )}
        </List.Item>
      )}
    </ListItemWrapper>
  );
};

InnerListItem.defaultProps = {
  disabled: false,
  disabledTooltipText: null,
  draggable: false,
};

export { InnerListItem };
